import { Collapse, Empty, Space, Tag, Typography } from "@arco-design/web-react";

import type { AuthzChangeItem } from "../types";

/** 展示角色最近两次授权变化。 */
export function RecentAuthorizationChanges({ items }: { items: AuthzChangeItem[] }) {
  if (!items.length) return <Empty description="暂无授权变化" />;
  return (
    <Collapse defaultActiveKey={[]}>
      {items.slice(0, 2).map((item) => (
        <Collapse.Item
          key={String(item.id)}
          name={String(item.id)}
          header={`${item.createdAt} · ${item.operatorName} · ${item.summary}`}
        >
          <Space direction="vertical" size={8}>
            <ChangeTags label="新增成员" values={item.addedUserIds.map(String)} color="green" />
            <ChangeTags label="移除成员" values={item.removedUserIds.map(String)} color="orangered" />
            <ChangeTags label="新增权限" values={item.addedPermissionCodes} color="arcoblue" />
            <ChangeTags label="移除权限" values={item.removedPermissionCodes} color="gray" />
          </Space>
        </Collapse.Item>
      ))}
    </Collapse>
  );
}

/** 渲染一组授权变化标签。 */
function ChangeTags({ label, values, color }: { label: string; values: string[]; color: string }) {
  if (!values.length) return null;
  return (
    <div>
      <Typography.Text style={{ marginRight: 8 }}>{label}</Typography.Text>
      {values.map((value) => <Tag key={value} color={color}>{value}</Tag>)}
    </div>
  );
}
